import { Picture } from '@/components/ui/Picture'

/**
 * The Longevity Gap — editorial spread: vibrant photo anchor on the left +
 * a single column of manifesto text on the right, anchored by the $100T
 * purchasing-power stat. Copy per Website Review V2.
 */
export function Challenge() {
  return (
    <section
      id="challenge"
      aria-labelledby="challenge-title"
      className="bg-surface py-section-y"
    >
      <div className="mx-auto grid max-w-[88rem] grid-cols-1 gap-x-12 gap-y-10 px-6 sm:px-10 lg:grid-cols-[5fr_7fr] xl:gap-x-16">
        {/* Photo anchor */}
        <figure>
          {/* Landscape crop on phones so the photo doesn't fill a whole screen. */}
          <div className="relative aspect-[4/3] overflow-hidden bg-surface-alt sm:aspect-[3/2] lg:aspect-[4/5]">
            <Picture
              name="longevity-gap"
              sizes="(min-width: 1024px) 40vw, 100vw"
              alt="An active woman in her late sixties laughing in a bright, plant-filled modern workspace."
              className="h-full w-full object-cover object-[50%_30%]"
            />
          </div>
          <figcaption className="mt-3 text-xs uppercase tracking-[0.14em] text-ink-faint">
            Longer lives are the opportunity of our time.
          </figcaption>
        </figure>

        {/* Manifesto column — copy per Website Review V2 */}
        <div className="min-w-0 lg:pt-4">
          <span className="eyebrow">The opportunity</span>

          <h2
            id="challenge-title"
            className="mt-4 font-display text-display-3 font-extrabold text-ink-deep"
          >
            The Longevity Gap
          </h2>

          <p className="mt-8 text-base leading-relaxed text-ink-slate sm:text-lg">
            By 2030, people over 60 will outnumber children under 5. By 2050,
            there will be more than 2 billion people over 65.
          </p>
          <p className="mt-4 text-base leading-relaxed text-ink-slate sm:text-lg">
            Yet most products, services, workplaces, and systems were designed
            for shorter lives. The opportunity to co-design the longevity
            ecosystem is now.
          </p>

          {/* Pull quote — the purchasing-power stat as the visual anchor */}
          <blockquote className="mt-10 border-l-4 border-brand pl-6">
            <p className="font-display text-2xl font-bold leading-snug text-ink-deep sm:text-3xl">
              Tap into the nearly{' '}
              <span className="text-brand-strong">$100 trillion</span> projected
              purchasing power of older adults.
            </p>
          </blockquote>

          <p className="mt-10 text-base leading-relaxed text-ink-slate sm:text-lg">
            Co-design and innovate for aging at every stage of life to create a
            future where living longer means living better.
          </p>
        </div>
      </div>
    </section>
  )
}
